import React, { useState } from 'react'; 
import './blog-post.css'; 
import './blog-slides.css';  
//pictures here
import hiya1 from './pictures/hiyapanel1.jpg';  
import hiya2 from './pictures/hiyapanel2.jpg'; 
import hiya3 from './pictures/hiyapanel3.jpg'; 
import hiya4 from './pictures/hiyapanel4.jpg'; 
import hiya5 from './pictures/hiyapanel5.jpg'; 

const HiyaX = () => {
  return (
    <div>
      <div className='blog__container'>
        <div className="row">
          <div className="column">
            <header>
              <h3 className="site-post-title rounded title-padding">
                <b>WiC at Work</b>
              </h3>
            </header>
            <section>
              <h2>WiC Early Career Panel with Hiya!</h2>
              <p className="site-post-meta">February 10th, 2025</p>
              <hr />
            </section>
            <section>
              <p>
                Hi WiC members!
                <br />
                <br />
                On Monday, February 10th, WiC hosted our WiC Early Career Panel with Hiya event! It was an incredible opportunity to learn from the Hiya team, who shared their experiences and insights from their careers in the tech industry. Attendees had the chance to ask questions during the panel discussion, receive career advice, and network with industry professionals. A big thank you to Hiya and everyone who attended!
              </p>
              <img src={hiya1} alt="Hiya Panel Event 1" />
              <img src={hiya2} alt="Hiya Panel Event 2" />
              <img src={hiya3} alt="Hiya Panel Event 3" />
              <img src={hiya4} alt="Hiya Panel Event 4" />
              <img src={hiya5} alt="Hiya Panel Event 5" />
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HiyaX;